export enum USER_ROLE {
  superAdmin = 0,
  admin = 1,
  user = 2,
  affiliate = 3,
  agency = 4,
  agencyMember = 5,
  individualAgent = 6,
}

const ROLE_ALIASES: Record<string, USER_ROLE> = {
  superadmin: USER_ROLE.superAdmin,
  admin: USER_ROLE.admin,
  user: USER_ROLE.user,
  affiliate: USER_ROLE.affiliate,
  agency: USER_ROLE.agency,
  agencymember: USER_ROLE.agencyMember,
  individualagent: USER_ROLE.individualAgent,
};

export function normalizeUserRole(role: unknown): USER_ROLE {
  if (role == null || role === '') return USER_ROLE.user;

  const normalized = String(role).trim();
  const numericRole = Number(normalized);

  if (
    Number.isInteger(numericRole) &&
    numericRole >= USER_ROLE.superAdmin &&
    numericRole <= USER_ROLE.individualAgent
  ) {
    return numericRole as USER_ROLE;
  }

  const alias = normalized.toLowerCase().replace(/[\s_-]/g, '');
  return ROLE_ALIASES[alias] ?? USER_ROLE.user;
}

export const USER_ROLE_LABELS: { [key: number]: string } = {
  [USER_ROLE.superAdmin]: 'Super Admin',
  [USER_ROLE.admin]: 'Admin',
  [USER_ROLE.user]: 'User',
  [USER_ROLE.affiliate]: 'Affiliate',
  [USER_ROLE.agency]: 'Agency',
  [USER_ROLE.agencyMember]: 'Agency Member',
  [USER_ROLE.individualAgent]: 'Individual Agent',
};
